"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.featuresQuery = void 0;
const react_query_1 = require("@tanstack/react-query");
const featureRepository_1 = __importDefault(require("../repositories/featureRepository"));
const query_keys_1 = require("./query-keys");
exports.featuresQuery = (0, react_query_1.queryOptions)({
    queryKey: [query_keys_1.featureKeys.getFeatureList],
    queryFn: featureRepository_1.default.getFeaturesList,
});
